import { ReactElement, Suspense } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Typography } from '@weareopenr/component-library';
import RadioButton from '../RadioButton';
import { StyledRadioButtonGroupBox } from './RadioButtonGroup.styles';
import styles from './RadioButtonGroup.module.scss';
import { useLocation } from 'react-router-dom';

export interface RadioButtonOptionProps {
  option: string;
  LogoComponent: React.ComponentType | React.LazyExoticComponent<React.ComponentType>;
  toolTipText: string;
  label: string;
}

const RadioButtonGroup = ({
  radioButtonGroupName,
  radioOptions,
  control,
}: {
  radioButtonGroupName: string;
  control: Control<any>;
  radioOptions?: RadioButtonOptionProps[];
}): ReactElement => {
  const location = useLocation();

  return (
    <Controller
      rules={{ required: 'Please choose a type' }}
      defaultValue={''}
      control={control}
      name={radioButtonGroupName}
      render={({ field, fieldState: { error } }) => {
        return (
          <>
            <StyledRadioButtonGroupBox
              {...field}
              role="radiogroup"
              fullwidth={(radioOptions.length === 2 && !location.pathname.includes('menu')).toString()}
            >
              {radioOptions.map(({ option, LogoComponent, toolTipText, label }) => {
                return (
                  <RadioButton
                    key={label}
                    isSelected={field.value === option}
                    name={radioButtonGroupName}
                    value={option}
                    label={label}
                    toolTipText={toolTipText}
                    hideRadio={true}
                    logo={
                      <Suspense fallback={<></>}>
                        <LogoComponent />
                      </Suspense>
                    }
                    error={error}
                  />
                );
              })}
            </StyledRadioButtonGroupBox>
            {error && <Typography className={styles['error-text']}>{error.message}</Typography>}
          </>
        );
      }}
    />
  );
};

export default RadioButtonGroup;
